import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";

export default function Article() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/articles/${slug}`).then((r) => setArticle(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="py-20 px-6 max-w-3xl mx-auto text-center" data-testid="article-not-found">
        <h1 className="font-serif text-3xl">Article not found</h1>
        <Link to="/knowledge" className="mt-6 inline-block text-[#D4AF37] uppercase text-xs tracking-[0.2em]">← Back to Knowledge</Link>
      </div>
    );
  }
  if (!article) return <div className="py-20 px-6 text-white/50">Loading…</div>;

  return (
    <article className="py-20 md:py-28 px-6 md:px-10 max-w-3xl mx-auto" data-testid="article-page">
      <Link to="/knowledge" className="overline text-[#D4AF37]">← Knowledge Center</Link>
      <h1 className="font-serif text-4xl md:text-5xl tracking-tight mt-6">{article.title}</h1>
      <div className="mt-3 text-xs uppercase tracking-[0.2em] text-white/50">{article.category}</div>
      {article.image_url && (
        <img src={article.image_url} alt={article.title} className="mt-10 w-full aspect-[16/9] object-cover border border-white/10" />
      )}
      <div className="mt-10 prose prose-invert max-w-none text-white/80 leading-relaxed text-lg whitespace-pre-line font-serif">
        {article.content}
      </div>
    </article>
  );
}
